export * from "./config-after-login.view";
